import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from './ThemeContext';
import { ArrowUpRight } from 'lucide-react';
import { api } from './api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await api.login(email, password);
      
      if (response.success) {
        navigate('/admin');
      } else {
        setError('Ungültige Anmeldedaten');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Login fehlgeschlagen. Bitte versuche es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`min-h-screen ${theme.colors.bg} ${theme.colors.text} font-mono flex items-center justify-center`}>
      <div className={`w-full max-w-md p-8 border ${theme.colors.border} rounded-lg`}>
        <h1 className={`text-3xl font-mono mb-8 ${theme.colors.text} text-center`}>Login</h1>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className={`block mb-2 ${theme.colors.text}`}>E-Mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`w-full px-4 py-2 border ${theme.colors.border} ${theme.colors.bg} ${theme.colors.text} rounded focus:outline-none focus:ring-2 focus:ring-blue-500`}
              required
            />
          </div>
          <div>
            <label className={`block mb-2 ${theme.colors.text}`}>Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`w-full px-4 py-2 border ${theme.colors.border} ${theme.colors.bg} ${theme.colors.text} rounded focus:outline-none focus:ring-2 focus:ring-blue-500`}
              required
            />
          </div>
          {error && (
            <div className={`p-3 rounded ${theme.isDarkMode ? 'bg-red-900/30 text-red-300' : 'bg-red-100 text-red-800'}`}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className={`w-full header-button font-mono ${theme.isDarkMode ? 'header-button-dark' : ''} flex items-center justify-center gap-2 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <span>{loading ? 'Anmeldung...' : 'Anmelden'}</span>
            {!loading && <ArrowUpRight size={14} />}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

